module.exports = __webpack_public_path__ + "img/snapchat.72d6639e.png";